import { beforeEnterMicrofrontend } from '@/router/routes/business/inventory/utils/beforeEnterMicrofrontend'

export default [
  {
    path: ':path(deliveries.*)?',
    name: 'inventory.deliveries',
    beforeEnter: beforeEnterMicrofrontend('deliveries'),
    component: () => import('@/views/business/inventory/deliveries/iframe-service.vue'),
  },
]
